import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Warriors from './views/Warriors.vue'
import Warrior from './views/Warrior.vue'
import Articles from './views/Articles.vue'
import Article from './views/Article.vue'
import Shop from './views/Shop.vue'
import Product from './views/Product.vue'
import About from './views/About.vue'
import Contact from './views/Contact.vue'
import Terms from './views/Terms.vue'
import P404 from './views/P404.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        grey: false,
        goBack: false,
        title: 'labor of fashion',
        size: 'small',
        color: 'white',
        translated: true
      }
    },
    {
      path: '/warriors',
      name: 'warriors',
      component: Warriors,
      meta: {
        grey: false,
        goBack: false,
        title: 'warriors',
        size: 'small',
        color: 'white',
        translated: true
      }
    },
    {
      path: '/warriors/:id',
      name: 'warrior',
      component: Warrior,
      meta: {
        grey: false,
        goBack: '/warriors',
        title: 'labor of fashion',
        size: 'small',
        color: 'black',
        translated: true
      }
    },
    {
      path: '/articles',
      name: 'articles',
      component: Articles,
      meta: {
        grey: false,
        goBack: false,
        title: 'labor of fashion',
        size: 'small',
        color: 'white'
      }
    },
    {
      path: '/articles/:id',
      name: 'article',
      component: Article,
      meta: {
        grey: false,
        goBack: '/articles',
        title: 'labor of fashion',
        size: 'small',
        color: 'black'
      }
    },
    {
      path: '/shop',
      name: 'shop',
      component: Shop,
      meta: {
        grey: false,
        goBack: false,
        title: 'lof',
        size: 'medium',
        color: 'white'
      }
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Product,
      meta: {
        grey: false,
        goBack: '/shop',
        title: 'lof',
        size: 'medium',
        color: 'black'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        grey: true,
        goBack: false,
        title: 'lof',
        size: 'big',
        color: 'black'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        grey: true,
        goBack: false,
        title: '',
        color: 'black'
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        grey: false,
        goBack: false,
        title: 'labor of fashion',
        size: 'small',
        color: 'white'
      }
    },
    {
      path: '/*',
      name: '404',
      component: P404,
      meta: {
        grey: false,
        goBack: false,
        title: '',
        color: 'black'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {

    let position = { x: 0, y: 0 }

    if(to.name === 'shop')
    {
      position = null
    }
    
    return position
  },
  mode: 'history'
})
